export const content = {
  titel: 'Rückmeldungen aus dem Ausschreibungsportal',
  antwortAngenommen: 'Antwort angenommen',
  antwortUnterVorbehaltAngenommen: 'Antwort unter Vorbehalt angenommen',
  antwortAbgelehnt: 'Antwort abgelehnt',
  ausschreibungAbgelaufen: 'Ausschreibung abgelaufen',
  angebotAbgelaufen: 'Angebot abgelaufen',
  vorschlaegePruefen: 'Vorschläge prüfen',
  vorschlagAendern: 'Vorschlag ändern',
  vorschlagUebernommen: 'Vorschlag übernommen',
  leer: '-',
};
